export const BreakdownDriverTypes = {
    shipment: 'Shipment',
    associate: 'Associate',
    rescueDriver: 'Rescue Driver',
    loadBoard: 'LoadBoard',
};
